<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_patient')">
    <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
    <FKBreadCrumbItem :page="patientFullName" :to="`/patient/${patient_id}`" />
  </FKBreadCrumb>
  <PatientForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import PatientForm from "@/components/FK/Patient/PatientForm.vue";
import { PatientInfo } from "@/utils/models/user.model";

export default defineComponent({
  name: "PatientFormPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    PatientForm,
  },
  computed: {
    patientFullName() {
      const patient = this.$route.meta.patient as PatientInfo;
      return `${patient.firstname} ${patient.lastname}`
    },
    patient_id() {
      return (this.$route.meta.patient as PatientInfo).id!;
    }
  }
});
</script>